import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Modal,
  Button,
  Row,
  Col,
  TextField,
  RadioButton,
  Loading,
} from '@folio/stripes/components';

const OpenTransactionsReportModal = ({
  open,
  onClose,
  onExport,
  isLoading,
  userName,
}) => {
  const intl = useIntl();
  const [reportName, setReportName] = useState(
    intl.formatMessage(
      { id: 'ui-users.openTransactions.report.defaultName' },
      { userName }
    )
  );
  const [exportFormat, setExportFormat] = useState('pdf');

  const handleExport = () => {
    onExport(reportName, exportFormat);
  };

  const footer = (
    <div>
      <Button onClick={onClose} disabled={isLoading}>
        <FormattedMessage id="ui-users.cancel" />
      </Button>
      <Button buttonStyle="primary" onClick={handleExport} disabled={isLoading}>
        {isLoading ? (
          <Loading />
        ) : (
          <FormattedMessage id="ui-users.openTransactions.report.export" />
        )}
      </Button>
    </div>
  );

  return (
    <Modal
      open={open}
      label={<FormattedMessage id="ui-users.openTransactions.report.title" />}
      footer={footer}
      onClose={onClose}
      size="small"
    >
      <Row>
        <Col xs={12}>
          <TextField
            label={<FormattedMessage id="ui-users.openTransactions.report.name" />}
            value={reportName}
            onChange={(e) => setReportName(e.target.value)}
            required
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <fieldset>
            <legend>
              <FormattedMessage id="ui-users.openTransactions.report.format" />
            </legend>
            <RadioButton
              label={
                <FormattedMessage id="ui-users.openTransactions.report.format.pdf" />
              }
              checked={exportFormat === 'pdf'}
              onChange={() => setExportFormat('pdf')}
              name="exportFormat"
            />
            <RadioButton
              label={
                <FormattedMessage id="ui-users.openTransactions.report.format.excel" />
              }
              checked={exportFormat === 'excel'}
              onChange={() => setExportFormat('excel')}
              name="exportFormat"
            />
          </fieldset>
        </Col>
      </Row>
    </Modal>
  );
};

OpenTransactionsReportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  userName: PropTypes.string,
};

OpenTransactionsReportModal.defaultProps = {
  isLoading: false,
  userName: '',
};

export default OpenTransactionsReportModal;
